<div class="container">
  <h1 mat-card-title>{{ title }}</h1>
  <mat-dialog-content>
    <table-responsive
      [length]="length"
      (changePage)="changePage($event)"
      (filter)="filter($event)"
      [displayedColumns]="displayedColumns"
      [dataSource]="dataSource"
      [configColumns]="configColumns"
      (openShow)="_openShow($event)"
      [hasAdd]="false"
      (openEdit)="_openEdit($event)"
      (openDelete)="openDelete($event)"
      [type]="dataSelect.type"
      (onSelect)="onSelect($event)"
    ></table-responsive>
  </mat-dialog-content>
  <div
    class="dynamic-field form-button"
    align="end"
    style="margin-top: 20px"
    *ngIf="dataSelect.select"
    (click)="onCancel()"
  >
  </div>
</div> 